import {Injectable} from '@angular/core';
import {Configparams} from '../model/configmodel/configparams';
import {AppConfigService} from '../config/app-config.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {
	token:any
	environment: any
	constructor(private readonly appConfigService: AppConfigService) {
		this.environment = environment;
	}

	isUSHostName() {
		const urlHostName = window.location.hostname;
		if (this.environment.validUSHostList.find(value => value === urlHostName)) {
			this.environment.validSingleHost = urlHostName;
			return true;
		}
		return false;
	}

	getAppConfigValue() {
		let appConfig: Configparams
		if (this.isUSHostName()) {
			appConfig = {
				vehicleCallUrl: this.environment?.vehicleCallUrl,
				imageCallUrl: this.environment?.digUrl + '/',
				region: 'US',
				modelsliceUrlBase1: this.environment?.modelSliceURL + '?showConfigData=true&showPaymentEstimatorV2=true&modelSliceDefiners=modelTrimName&make=Lincoln&modelAttributes=nameplateDisplayNameShort&',
				modelsliceUrlBase2: '&modelAttributes=NGB_Nameplate_DisplayName&modelSliceAttributes=BP3CC_SPC_TrimName_Label;BP3CC_SPC_ModelListParam_Thumbnail;ShoppingTools_Visible_In_BP;ShoppingTools_Visible_In_SI;ShoppingTools_Metrics_ModelName;NGB_Nameplate_Navigation_ShowMPG;NGB_Specifications_MPGCity_Min;NGB_Model_Specifications_MPGCity_Max;NGB_Specifications_MPGHwy_Min;NGB_Model_Specifications_MPGHwy_Max;BP2_Pages_VehicleName_Disclaimer&modelSliceDefiners=modelTrimName&planType=MSRP&showPaymentEstimatorV2=true&year=',
				paymentCaldesc: 'Use the Payment Calculator to configure your next Lincoln vehicle!',
				paymentCalTitle: 'Vehicle Payment Calculator | Lincoln Automotive Financial Services',
				zipCodeUrl: this.environment?.postalCodeURL + '?',
				client: 'lafs-usa',
				site: this.environment?.site
			}
		}
		// else {
		// 	//canada region check need to be included
		// 	if (this.isCAHostName()) {
		// 		appConfig = {
		// 			vehicelCallUrl: 'https://www.ford.com/services//products/ModelSlices.json?api_key=3441f9f4-9de5-ebf5-5c812dbc-4a26f2c3&appContext=SHOWROOM&filters=Showroom_Is_Displayed:true&make=Lincoln&modelAttributes=NGB_Nameplate_DisplayName;BP3CC_SPC_TrimName_Label;BP3CC_SPC_ModelListParam_Thumbnail;ShoppingTools_Visible_In_BP;ShoppingTools_Visible_In_SI;ShoppingTools_Metrics_ModelName;NGB_Nameplate_Navigation_ShowMPG;NGB_Specifications_MPGCity_Min;NGB_Specifications_MPGCity_Max;NGB_Specifications_MPGHwy_Min;NGB_Specifications_MPGHwy_Max&planType=MSRP',
		// 			imageCallUrl: 'https://build.ford.com/dig/',
		// 			region: 'CA',
		// 			modelsliceUrlBase1: 'https://www.ford.com/services//products/ModelSlices.json?api_key=3441f9f4-9de5-ebf5-5c812dbc-4a26f2c3&appContext=SHOWROOM&filters=Showroom_Is_Displayed:true&make=Lincoln&model=',
		// 			modelsliceUrlBase2: '&modelAttributes=NGB_Nameplate_DisplayName&modelSliceAttributes=BP3CC_SPC_TrimName_Label;BP3CC_SPC_ModelListParam_Thumbnail;ShoppingTools_Visible_In_BP;ShoppingTools_Visible_In_SI;ShoppingTools_Metrics_ModelName;NGB_Nameplate_Navigation_ShowMPG;NGB_Specifications_MPGCity_Min;NGB_Model_Specifications_MPGCity_Max;NGB_Specifications_MPGHwy_Min;NGB_Model_Specifications_MPGHwy_Max;BP2_Pages_VehicleName_Disclaimer&modelSliceDefiners=NGB_Nameplate_Definers&planType=MSRP&showPaymentEstimatorV2=true&year=',
		// 			paymentCaldesc: 'Use the Payment Estimator to configure your next Lincoln vehicle! Simply select your vehicle, select your trim, and input any relevant information regarding your preferred term, down payment and, if applicable, your current vehicle\'s Estimated Net Trade-In Amount. The Payment Estimator will then calculate an Estimated Selling Price, your Estimated Monthly Payment and more payment details.',
		// 			paymentCalTitle: 'Payment Estimator',
		// 			zipCodeUrl: 'https://www.cxservices.ford.com/geo/PostalCodes.json?',
		// 			client: 'lafs-can',
		// 			site: 'https://wwwqa.globalfinancecalculator.ford.ca/finance'
		//
		// 		}
		// 	}
		// }
		return appConfig;
	}

	isProd() {
		let res = false;
		if (window.location.hostname.indexOf("www.") > -1) {
			res = true;
		}
		return res;
	}
}
